import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { TooltipWithErrorBoundary as Tooltip, TooltipConstants, removeClickable } from '@Components/Tooltip';
import { placeBottomAlignRight } from '@Pages/Heatmap/HeatmapTooltipHeaders/tooltipOverridePosition';
import { getHoverTooltipContent } from '@Pages/Heatmap/HeatmapTooltipHeaders/getTooltipContent';
import { TooltipEvents } from './constants';

function HeatmapTooltipHeadersHoverCols({ dataMap, type }) {
  const onClose = useCallback(() => removeClickable(TooltipConstants.ids.HeatmapTooltipHeadersCols), []);

  return (
    <Tooltip
      id={TooltipConstants.ids.HeatmapTooltipHeadersCols}
      elsTooltip={false}
      className="heatmap-tooltip rs-tooltip-big"
      place="bottom"
      clickable
      overridePosition={placeBottomAlignRight}
      getContent={(index) => (index ? getHoverTooltipContent({ data: dataMap[index], type, onClose }) : null)}
      hideDelay={100}
      globalEventOff={TooltipEvents.ON_HOVER_EVENT}
      afterShow={TooltipEvents.hideOnClickTooltips}
    />
  );
}

HeatmapTooltipHeadersHoverCols.propTypes = {
  dataMap: PropTypes.object,
  type: PropTypes.string,
};

export default HeatmapTooltipHeadersHoverCols;
